import { render, staticRenderFns } from "./EditStockItem.vue?vue&type=template&id=43deee06&scoped=true&"
import script from "./EditStockItem.vue?vue&type=script&lang=js&"
export * from "./EditStockItem.vue?vue&type=script&lang=js&"
import style0 from "./EditStockItem.vue?vue&type=style&index=0&id=43deee06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43deee06",
  null
  
)

export default component.exports